import { render } from "./VLoaderXmasTree.vue?vue&type=template&id=5e7e3006"
const script = {}

import "./VLoaderXmasTree.vue?vue&type=style&index=0&id=5e7e3006&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__